// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — подтверждение проблемы)
// «Прийнято» — пользователь подтверждает проблему формы ячейки: проблема известна и согласована, бэк ставит отметку сигнала (kind 'accepted') и убирает
// запись из story.problems / story.info в блок ACCEPTED. Чистая логика (без Vue / DOM — юнит tests/unit/cellSignalAccept.test.mjs):
//   1) кнопка Accept у записи ПРОБЛЕМИ — только при problems[].can_accept === true (accept_of: problem_key + accept_row записи);
//   2) диалог: комментарий (обязателен), «Valid to» — дата 'YYYY-MM-DD' (необязательна; IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD) — раньше месяц →
//      последний день месяца) → valid_to = эта дата (принятие действует по неё включительно; пример бэка — '2026-12-31'); accept_validate / accept_params;
//   3) метод виджета отчёта cell_signal_accept({accept_row, problem_key, comment, valid_to?}) и cell_signal_unaccept({mark_id} | {accept_row}) — ответ
//      {command: 'updateDoc', <метод>: {state: 'ok' | 'off' | 'error: …', mark_id, already?, switch?}}; accept_result — разбор (already: true — успех);
//      accept_send — вызов через store.executeWidgetMethod и, при успехе, перечитывание cell_passport ячейки (story) — как после принятия решения;
//   4) блок ACCEPTED: story.accepted[] → строки (accepted_list), счётчик заголовка — story.accepted_n (accepted_count);
//   5) статус проблемы 'accepted' (бэк PROBLEM-STATUS_accepted) — бейдж «Accepted» (accept_statusOf).
// Флаг fe.ux.cellSignalAccept (дефолт ВКЛ; выкл — ни кнопки, ни блока, ни бейджа).
import { t } from '@/i18n'

export const ACCEPT_FLAG = 'fe.ux.cellSignalAccept'
export const ACCEPT_METHOD = 'cell_signal_accept'
export const UNACCEPT_METHOD = 'cell_signal_unaccept'
export const ACCEPT_TIMEOUT_MS = 60000   // IE 2026 10 28 / ODOO-5800 (ie-dm7 #113095, бот r52: обрыв запроса — диалог крутился без конца): нет ответа минуту — ошибка в диалоге, кнопки снова доступны
export const ACCEPT_COMMENT_MAX = 1000

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const str = (v) => (v === undefined || v === null) ? '' : String(v).trim()
const num = (v) => { const n = Number(v); return (v === null || v === undefined || v === '' || !isFinite(n)) ? null : n }

// чтение флага: нет читателя / ошибка — ВКЛ
export function accept_on(setting) {
    try { return typeof setting === 'function' ? setting(ACCEPT_FLAG, true) !== false : true } catch (e) { return true }
}

// запись ПРОБЛЕМИ, которую можно принять: {problem_key, accept_row} — только при can_accept === true и объекте accept_row; иначе null
export function accept_of(problem) {
    if (!isObj(problem) || problem.can_accept !== true || !isObj(problem.accept_row)) return null
    return { problem_key: str(problem.problem_key), accept_row: { ...problem.accept_row } }
}

// статус проблемы бэка 'accepted' (PROBLEM-STATUS_accepted)
export function accept_statusOf(problem) {
    return isObj(problem) && str(problem.status).toLowerCase() === 'accepted'
}

// последний день месяца 'YYYY-MM' → 'YYYY-MM-DD'; не месяц — ''
export function accept_monthEnd(month) {
    const m = /^(\d{4})-(\d{2})$/.exec(str(month))
    if (!m) return ''
    const y = +m[1], mo = +m[2]
    if (mo < 1 || mo > 12) return ''
    const d = new Date(Date.UTC(y, mo, 0)).getUTCDate()
    return `${m[1]}-${m[2]}-${String(d).padStart(2, '0')}`
}

// IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD): «Valid to» — полная дата; маска ввода: только цифры, дефисы вставляются сами → 'YYYY-MM-DD' (до 10 символов)
export function accept_dateMask(v) {
    const d = String(v === undefined || v === null ? '' : v).replace(/\D/g, '').slice(0, 8)
    return d.length > 6 ? d.slice(0, 4) + '-' + d.slice(4, 6) + '-' + d.slice(6) : d.length > 4 ? d.slice(0, 4) + '-' + d.slice(4) : d
}

// IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD): настоящая календарная дата 'YYYY-MM-DD' (2026-02-30 — нет) → та же строка; иначе ''
export function accept_dateOk(v) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str(v))
    if (!m) return ''
    const y = +m[1], mo = +m[2], d = +m[3]
    if (mo < 1 || mo > 12 || d < 1) return ''
    return d <= new Date(Date.UTC(y, mo, 0)).getUTCDate() ? m[0] : ''
}

// проверка формы диалога: {comment, date} → {ok, error, field, comment, valid_to}. Комментарий обязателен (пробелы — пусто), до 1000 символов;
// IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD): date — '' (без срока) | 'YYYY-MM-DD' (настоящая дата; valid_to = эта дата); месяц 'YYYY-MM' — ошибка
export function accept_validate(form) {
    const f = isObj(form) ? form : {}
    const comment = str(f.comment)
    if (!comment) return { ok: false, field: 'comment', error: t('A comment is required'), comment: '', valid_to: '' }
    const raw = str(f.date)   // IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD)
    let valid_to = ''
    if (raw) {
        valid_to = accept_dateOk(raw)
        if (!valid_to) return { ok: false, field: 'valid_to', error: t('Valid to: a date as YYYY-MM-DD'), comment, valid_to: '' }   // IE 2026 10 28 / ODOO-5800 (Igor via ie-dm7 #113042: Valid to — full date YYYY-MM-DD)
    }
    return { ok: true, field: '', error: '', comment: comment.slice(0, ACCEPT_COMMENT_MAX), valid_to }
}

// params метода cell_signal_accept: acc — accept_of(записи), v — accept_validate(формы) с ok; valid_to — только если задан. Нет данных — null
export function accept_params(acc, v) {
    if (!isObj(acc) || !isObj(acc.accept_row) || !isObj(v) || !v.ok) return null
    const out = { accept_row: { ...acc.accept_row }, problem_key: str(acc.problem_key), comment: str(v.comment) }
    if (v.valid_to) out.valid_to = v.valid_to
    return out
}

// params метода cell_signal_unaccept: {mark_id} строки блока ACCEPTED; нет id — запасной ключ {accept_row}; нет ничего — null
export function unaccept_params(row) {
    if (!isObj(row)) return null
    const id = str(row.mark_id !== undefined ? row.mark_id : (isObj(row.mark) ? row.mark.id : ''))
    if (id) return { mark_id: id }
    if (isObj(row.accept_row)) return { accept_row: { ...row.accept_row } }
    return null
}

// время отметки ISO → 'YYYY-MM-DD HH:MM' (UTC бэка, как в паспорте ячейки); не строка — ''
function _at(v) {
    const s = str(v)
    return s ? s.slice(0, 16).replace('T', ' ') : ''
}

// строки блока ACCEPTED из story.accepted[] (сырой или нормализованный story): [{key, mark_id, problem_key, accept_row, code, title, full, qty, money,
// comment, by, by_title, at, valid_to, who, line, canCancel}]; флаг выкл / нет записей — []
export function accepted_list(story, on = true) {
    if (on === false || !isObj(story) || !Array.isArray(story.accepted)) return []
    const out = []
    story.accepted.forEach((x, i) => {
        if (!isObj(x)) return
        const mk = isObj(x.mark) ? x.mark : {}
        const code = str(x.code)
        const full = str(x.title) || code
        const title = str(x.short) || full
        const o = { key: 'accepted:' + (str(mk.id) || str(x.problem_key) || i), mark_id: str(mk.id), problem_key: str(x.problem_key),
            accept_row: isObj(x.accept_row) ? { ...x.accept_row } : null, code, title, full, qty: num(x.qty), money: isObj(x.money) ? x.money : null,
            comment: str(mk.comment), by: str(mk.by), by_title: str(mk.by_title) || str(mk.by), at: _at(mk.at), valid_to: str(mk.valid_to).slice(0, 10) }
        o.who = [o.by_title, o.at].filter(Boolean).join(' · ')
        o.line = [full !== title ? title + ' — ' + full : title, o.comment, o.who, o.valid_to ? t('Valid to') + ': ' + o.valid_to : ''].filter(Boolean).join('\n')
        o.canCancel = !!(o.mark_id || o.accept_row)
        out.push(o)
    })
    return out
}

// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012, #106379: «Прийнято» — блок под ПРОБЛЕМИ, цепочка принятой записи): запись accepted[] нового бэка — вся запись проблемы (есть kind и text_parts) → строка-цепочка; иначе (старый бэк) — title / short
export function accept_isFull(x) {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012, #106379: «Прийнято» — блок под ПРОБЛЕМИ, цепочка принятой записи)
    return isObj(x) && !!str(x.kind) && str(x.kind) !== 'none' && Array.isArray(x.text_parts)
}
// N заголовка «ACCEPTED · N» — accepted_n бэка (длина до обрезки), нет — длина списка; флаг выкл — 0
export function accepted_count(story, on = true) {
    if (on === false || !isObj(story)) return 0
    const n = num(story.accepted_n)
    return n !== null && n > 0 ? n : (Array.isArray(story.accepted) ? story.accepted.filter(isObj).length : 0)
}

// ответ метода → {ok, off, already, state, field, mark_id, text}. answer — ответ executeWidgetMethod ({<метод>: {...}}) либо сам объект метода.
// ok — state 'ok' либо повтор (already: true) без ошибки; off — выключатель бэка (кнопку прячем); error: … — текст ошибки для подписи / тоста
export function accept_result(answer, method = ACCEPT_METHOD) {
    const a = isObj(answer) ? answer : {}
    const r = isObj(a[method]) ? a[method] : (typeof a.state === 'string' ? a : { state: 'error' })
    const state = str(r.state) || 'error'
    const un = method === UNACCEPT_METHOD
    const base = { ok: false, off: false, already: r.already === true, state, field: '', mark_id: str(r.mark_id), text: '' }
    if (state === 'off') return { ...base, off: true, text: t('Accepting problems is switched off ({switch})', { switch: str(r.switch) || 'signals_accept' }) }
    if (state.startsWith('error')) {
        const detail = state.replace(/^error:?\s*/, '')
        if (!un && /comment is required/i.test(detail)) return { ...base, field: 'comment', text: t('A comment is required') }
        return { ...base, text: (un ? t('The acceptance is not cancelled') : t('The problem is not accepted')) + (detail ? ': ' + detail.slice(0, 120) : '') }
    }
    if (state === 'ok' || base.already) {
        const text = un ? (base.already ? t('The acceptance was already cancelled') : t('The acceptance is cancelled'))
            : (base.already ? t('The problem was already accepted') : t('The problem is accepted'))
        return { ...base, ok: true, text }
    }
    return { ...base, text: (un ? t('The acceptance is not cancelled') : t('The problem is not accepted')) + ': ' + state.slice(0, 120) }
}

// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора):
// после ok форма перечитывается ЦЕЛИКОМ тем же путём, что при открытии: AttrGrid.cellPassport_load(dropdown, dataItem, binding, irow) — тот же where строки
// (cellPassport_rowWhere), months итога периода, group подчинённых строк у итоговой строки без субъекта, story = 1. Прежний story-only запрос {where, month, story: 1}
// шёл только при subject в where: у итоговой / страновой строки форма открывается с params.group (и months), и голый where дал бы бэку story другого охвата —
// поэтому без subject была только плашка «reopen the cell form». Выключатель fe.ux.cellSignalAcceptFullReload (дефолт ВКЛ; выкл — прежнее)
export const ACCEPT_RELOAD_FLAG = 'fe.ux.cellSignalAcceptFullReload'   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора)
// ячейка открытой формы: dropdown.key '<тип>-<строка>-<колонка>' (AttrGrid.dropdown_prepare) → {irow, binding, dataItem}; как AttrGrid.cellPassport_refreshUnsaved. Нет — null
export function accept_reloadCell(grid, dropdown) {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора)
    if (!grid || !dropdown || !dropdown.dataItem) return null
    const m = /^(.*)-(\d+)-(\d+)$/.exec(str(dropdown.key))
    if (!m) return null
    const cols = grid.flex && grid.flex.columns
    const col = cols ? cols[Number(m[3])] : null
    const binding = col && col.binding
    if (!binding) return null
    return { irow: Number(m[2]), binding: String(binding), dataItem: dropdown.dataItem }
}
// вызов метода виджета отчёта и перечитывание story ячейки после успеха (тот же путь, что после принятия решения — cellStory.story_solutionSend):
// grid — AttrGrid формы (store, WIDGET, cellStory_apply, _cellPassportSeq), dropdown — форма (_storyCtx {where, month}, _storyCell);
// req: {method: ACCEPT_METHOD | UNACCEPT_METHOD, params, done(result)} — done получает accept_result; тост — store.show_notification
export function accept_send(grid, dropdown, req) {
    const done = req && typeof req.done === 'function' ? req.done : () => {}
    const method = req && req.method
    const store = grid && grid.store
    const fail = { ok: false, off: false, already: false, state: 'error', field: '', mark_id: '', text: method === UNACCEPT_METHOD ? t('The acceptance is not cancelled') : t('The problem is not accepted') }
    if (!store || typeof store.executeWidgetMethod !== 'function' || !req || !isObj(req.params) || (method !== ACCEPT_METHOD && method !== UNACCEPT_METHOD)) { done(fail); return false }
    const ctx = dropdown && isObj(dropdown._storyCtx) ? dropdown._storyCtx : null
    const cellKey = dropdown ? dropdown._storyCell : ''
    const ddKey = dropdown ? dropdown.key : undefined   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора): ячейка формы на момент отправки
    const opts = { record_sendToBackend_exclude: ['_doc'], widget_sendToBackend_exclude: ['view'], no_del_last_backend_action: true }
    const note = (text, status) => { try { store.show_notification({ text, status, timeout: 7000 }) } catch (e) { /* стора уведомлений нет */ } }
    // IE 2026 10 28 / ODOO-5800 (ie-dm7 #113095, бот r52: обрыв запроса — диалог крутился без конца): ошибка запроса (_onResponse(null) — сеть / 5xx), обрыв (_onAbort) и нет ответа за ACCEPT_TIMEOUT_MS — done(ошибка): диалог снимает
    // загрузку, показывает ошибку и возвращает кнопки; ответ, пришедший позже, применяется как обычно
    let answered = false, failed = false
    const failNet = () => {
        if (answered || failed) return
        failed = true
        const res = { ...fail, text: fail.text + ': ' + t('Could not reach the server. Check your connection and try again') }
        done(res)
        note(res.text, 'error')
    }
    const timer = setTimeout(failNet, ACCEPT_TIMEOUT_MS)
    if (timer && typeof timer.unref === 'function') timer.unref()
    store.executeWidgetMethod({ WIDGET: grid.WIDGET }, { command: 'executeWidgetMethod', method, params: req.params, ...opts,
        _onResponse: (a) => { if (a === null) { clearTimeout(timer); failNet() } },   // IE 2026 10 28 / ODOO-5800 (ie-dm7 #113095, бот r52: обрыв запроса — диалог крутился без конца)
        _onAbort: () => { clearTimeout(timer); failNet() },   // IE 2026 10 28 / ODOO-5800 (ie-dm7 #113095, бот r52: обрыв запроса — диалог крутился без конца)
        _response_callback: (answer) => {
            answered = true; clearTimeout(timer)   // IE 2026 10 28 / ODOO-5800 (ie-dm7 #113095, бот r52: обрыв запроса — диалог крутился без конца)
            if (answer) { answer.command = ''; delete answer.updates }   // ответ нужен только форме (как у cell_passport)
            const res = accept_result(answer, method)
            done(res)
            note(res.text, res.ok ? 'success' : 'warning')
            if (!res.ok) return
            let fullOn = true; try { fullOn = typeof store.setting === 'function' ? store.setting(ACCEPT_RELOAD_FLAG, true) !== false : true } catch (e) { fullOn = true }   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора)
            if (fullOn && typeof grid.cellPassport_load === 'function') {   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — перечитывание формы после ok у любой ячейки, проба dev02 координатора): любой where — путь открытия формы
                if (!dropdown || dropdown.key !== ddKey || dropdown.visible === false || (dropdown.vueObj && dropdown.vueObj !== grid)) return   // форма закрыта / уже на другой ячейке
                const c = accept_reloadCell(grid, dropdown)
                if (c) { try { grid.cellPassport_load(dropdown, c.dataItem, c.binding, c.irow); return } catch (e) { /* ниже — плашка */ } }
                note(method === UNACCEPT_METHOD ? t('The acceptance is cancelled — reopen the cell form') : t('The problem is accepted — reopen the cell form'), 'info')
                return
            }
            const hasSubject = !!ctx && Array.isArray(ctx.where) && ctx.where.some(w => Array.isArray(w) && (w[0] === 'subject' || w[0] === 'calc_subject'))
            if (!ctx || !hasSubject || typeof grid.cellStory_apply !== 'function') {
                note(method === UNACCEPT_METHOD ? t('The acceptance is cancelled — reopen the cell form') : t('The problem is accepted — reopen the cell form'), 'info')
                return
            }
            store.executeWidgetMethod({ WIDGET: grid.WIDGET }, { command: 'executeWidgetMethod', method: 'cell_passport', params: { where: ctx.where, month: ctx.month, story: 1 }, ...opts,
                _response_callback: (ans) => {
                    if (ans) { ans.command = ''; delete ans.updates }
                    if (!dropdown || dropdown._storyCell !== cellKey) return   // форма уже на другой ячейке
                    const st = ans && ans.cell_passport && ans.cell_passport.story
                    if (st) { try { grid.cellStory_apply(dropdown, st, { where: ctx.where, month: ctx.month, seq: grid._cellPassportSeq }) } catch (e) { /* story прежняя */ } }
                } })
        } })
    return true
}
